import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../components/PageLayout';
import _t from 'counterpart';
import { CCard, CCardBody, CListGroup, CListGroupItem, CPagination } from '@coreui/react';
import { useQuery, useQueryClient } from 'react-query';
import { fetchAdminNotifications, markAllAdminNotificationsRead } from '../../services/BackendService';
import { extractErrorMessage, formatDateTime } from '../../helpers';
import toast from 'react-hot-toast';
import { INotification } from './types';
import NoNotificationsPlaceholder from './NoNotificationsPlaceholder';

const AdminNotificationsPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const queryClient = useQueryClient();

  const ITEMS_PER_PAGE = 20;

  useEffect(() => {
    markAllAdminNotificationsRead()
      .then(() => {
        queryClient.invalidateQueries('admin-notifications-count');
        queryClient.invalidateQueries('notifications');
      })
      .catch(() => {});
  }, [queryClient]);

  const fetchNotificationsQuery = useQuery(
    ['notifications', currentPage],
    () => fetchAdminNotifications(ITEMS_PER_PAGE, currentPage - 1),
    {
      onError: (e: any) => {
        const error = extractErrorMessage(e);
        toast.error(error);
      },
    }
  );

  const notifications: Array<INotification> = fetchNotificationsQuery.data?.notifications || [];

  const count = fetchNotificationsQuery.data?.count || 0;

  const pageCount = Math.ceil(count / ITEMS_PER_PAGE);

  return (
    <PageLayout title={_t('notifications.title')} titleAppend={undefined}>
      <CCard>
        <CCardBody className="p-0">
          {count === 0 && <NoNotificationsPlaceholder />}
          {count > 0 && (
            <CListGroup flush>
              {notifications.map((notification: INotification, idx: number) => (
                  <CListGroupItem
                    key={notification.customerId + String(notification.createdAt) + idx}
                    className="d-flex justify-content-between align-items-start flex-column"
                    tag={Link}
                    to={`/customers/${notification.customerId}`}
                    action
                  >
                    <div className="d-flex justify-content-between w-100">
                      <strong>{notification.subject}</strong>
                      <small className="text-muted">{formatDateTime(notification.createdAt)}</small>
                    </div>
                    <div className="text-muted mt-1">{notification.message}</div>
                  </CListGroupItem>
              ))}
            </CListGroup>
          )}

          {pageCount > 1 && (
            <div className="d-flex justify-content-center p-3">
              <CPagination
                align="center"
                activePage={currentPage}
                pages={pageCount}
                onActivePageChange={setCurrentPage}
              ></CPagination>
            </div>
          )}
        </CCardBody>
      </CCard>
    </PageLayout>
  );
};

export default AdminNotificationsPage;
